import React from 'react';

const pageStates = ['search', 'category', 'search-product', 'category-product'];

export default class DesignCenterHeadline extends  React.Component {

    constructor(...arg){
        super(...arg);
        this.state = {
            namespace: null,
            search: null,
            urlQuery: null,
            pageState: null,
            error: null,
            catInfo: []
        }
    }

    componentDidMount() {
        fetch("/?product-category")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        catInfo: result
                    });
                },
                (error) => {
                    this.setState({
                        error
                    });
                }
            )
    }

    setNamespace = (namespace) => {
        this.setState({
            namespace,
        });
    };

    setUrlQuery = (urlQuery) => {
        this.setState({
            urlQuery,
        });
    };

    setPageState = (pageState) => {
        this.setState({
            pageState,
        });
    };

    setSearch = (search) => {
        this.setState({
            search,
        });
    };

    renderCatSidebar() {
        const isCart = this.state.namespace === 'cart' || this.state.namespace === 'checkout';
        const isCatalog = !isCart && pageStates.includes(this.state.pageState);

        if (isCatalog) {
            const catInfo = this.state.catInfo;
            //Object.entries(catInfo).map(([mainCatKey, mainCatVal]) => console.log(mainCatKey));

            const urlQuery = this.state.urlQuery;
            return Object.entries(catInfo).map(([mainCatKey, mainCatVal]) => [
                <a href={`${urlQuery}&cat=${mainCatKey}&type=${mainCatVal.topmostSlug}`} className={'headline-subtext design-center-headline__subtext'} key={mainCatKey}>{mainCatVal.name}</a>,
                <div className={'ml-1'} key={mainCatVal.name}>
                    {mainCatVal.children.map(cat => <a href={`${urlQuery}&cat=${cat.slug}&type=${mainCatVal.topmostSlug}`} className={'headline-subtext design-center-headline__subtext'} key={cat.slug}>{cat.name.replace(/&amp;/g,'&')}&nbsp;&nbsp;({cat.count})</a>)}
                </div>
            ]);
        } else {
            return <p className={'headline-subtext design-center-headline__subtext'}>{this.props.subtext}</p>;
        }
    }

    render() {
        const isCart = this.state.namespace === 'cart' || this.state.namespace === 'checkout';
        const isCheckout = this.state.namespace === 'checkout';
        const isCatalog = !isCart && pageStates.includes(this.state.pageState);

        const error = this.state.error;

        return <div className={'design-center-headline-wrapper'}>
            <div>
                <h1 className={'headline-text design-center-headline__text'}>{isCatalog ? 'PRODUCT CATALOG' : <div> <span style={{letterSpacing: '1.4px'}}> DESIGN </span> CENTER </div> }</h1>
                {this.renderCatSidebar()}
            </div>
            <div className={'design-center-bar'}>
                <div className='d-flex align-items-center'>
                    <div className={'circle design-center-headline__circle design-center-headline__circle--active'}></div>
                    <h6 className={'design-center-bar__text design-center-bar__text--active'}>Design</h6>
                </div>
                <div className={`design-center-headline__vertical-line ${isCart ? 'design-center-headline__vertical-line--active' : ''}`}></div>
                <div className='d-flex align-items-center'>
                    <div className={`circle design-center-headline__circle ${isCart ? 'design-center-headline__circle--active' : ''}`}></div>
                    <h6 className={`design-center-bar__text ${isCart ? 'design-center-bar__text--active' : ''}`}>Add to Cart</h6>
                </div>
                <div className={`design-center-headline__vertical-line ${isCheckout ? 'design-center-headline__vertical-line--active' : ''}`}></div>
                <div className='d-flex align-items-center'>
                    <div className={`circle design-center-headline__circle ${isCheckout ? 'design-center-headline__circle--active' : ''}`}></div>
                    <h6 className={`design-center-bar__text ${isCheckout ? 'design-center-bar__text--active' : ''}`}>Purchase</h6>
                </div>
            </div>
        </div>;
    }
}
